// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var TicketHeader$ReactHooksTemplate = require("./ticketHeader.res.js");
var TicketHeadersApi$ReactHooksTemplate = require("./TicketHeadersApi.res.js");

function fetchOverview(param) {
  return Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/tickets_header", (function (json) {
                var ticketHeaders = Json_decode.field("ticket_headers", (function (param) {
                        return Json_decode.list(TicketHeader$ReactHooksTemplate.decode, param);
                      }), json);
                var o = Json_decode.optional((function (param) {
                        return Json_decode.field("ticket_overview_column_order", (function (param) {
                                      return Json_decode.array(Json_decode.string, param);
                                    }), param);
                      }), json);
                var orderRaw = o !== undefined ? o : [];
                var columnOrder = TicketHeadersApi$ReactHooksTemplate.resolveColumnOrder(ticketHeaders, orderRaw);
                return [
                        ticketHeaders,
                        columnOrder
                      ];
              }));
}

exports.fetchOverview = fetchOverview;
/* Http-ReactHooksTemplate Not a pure module */
